<!--商品留言页面 -->
<template>
  <cc-container>
    <cc-header-nav class="header" title="商品留言">
      <template slot="right">
        <div class="ellipsis">
          <van-icon
            class="ellipsis-icon"
            name="ellipsis"
            @click.stop="isShowSmallNav = !isShowSmallNav"
          />
        </div>
      </template>
    </cc-header-nav>
    <cc-main class="main">
      <div class="message">
        <div class="message-tel">
          <span>
            <span style="color:#FF5B7A;">*</span>联系电话
          </span>
          <input type="text" v-model="params.tel" placeholder="请填写联系电话" />
        </div>
        <textarea v-model="params.content" class="message-content" placeholder="留言内容（150字以内）"></textarea>
      </div>
      <div class="submit" @click="sub()">提交</div>

    </cc-main>
    <cc-small-nav v-model="isShowSmallNav" />
  </cc-container>
</template>
<script>
import Vue from 'vue'
import { Icon, Toast } from 'vant'
import { addProposal } from './../../fetch/goods-details/index.js'
Vue.use(Icon)
  .use(Toast)

export default {
  data () {
    return {
      isShowSmallNav: false,
      params: {
        // 商品编码
        product_code: '',
        // 留言电话
        tel: '',
        // 留言内容
        content: ''
      }
    }
  },
  methods: {
    async sub () {
      this.params.product_code = this.$route.query.product_code
      let res = await addProposal(this.params)
      if (res.status) {
        Toast(res.info.msg)
      } else {
        Toast(res.info.msg)
        this.$router.back()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.ellipsis {
  width: 50%;
  height: 100%;
  @include center();
  transform: translateX(-5px);
  &-icon {
    transform: rotate(90deg);
  }
}
.main {
  margin: 10px 10px 0 10px;
  .message {
    // width: 100%;
    // height: 100%;
    border-radius: 10px;
    overflow: hidden;
    font-size: 12px;
    > div {
      background: #fff;
    }
    textarea,
    .message-tel {
      padding-left: 14.5px;
    }
    input,
    textarea {
      border: none;
    }
    &-tel {
      height: 45px;
      width: 100%;
      margin-bottom: 5px;
      display: flex;
      align-items: center;
      > span {
        margin-right: 30px;
      }
    }
    textarea {
      height: 125px;
      width: 355px;
    }
  }
  .submit {
    width: 355px;
    height: 40px;
    color: #fff;
    background: var(--APP_theme_color);
    border-radius: 20px;
    margin-top: 15px;
    font-size: 15px;
    display: flex;
    @include center();
  }
}
</style>
